import * as React from 'react';
import { useRouteMatch } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Modules } from '~/data/modules';
import { LegacyNotificationListPage } from '~/legacy-components/LegacyNotificationListPage';
import { useAppModules } from '~/scenes/AppModules/useAppModules';
import { MyTeam } from '~/scenes/MyTeam';
import { MyWorkspace } from '~/scenes/MyWorkspace';
import { HandleCurrentPageCookie } from '~/scenes/PortalViews/components/HandleCurrentPageCookie';
import { RedirectToPortalContinue } from '~/scenes/PortalViews/components/RedirectToPortalContinue';
import { RedirectToPortalHomepage } from '~/scenes/PortalViews/components/RedirectToPortalHomepage';
import { AdminViews } from '~/scenes/PortalViews/Views/AdminViews';
import { AnalyticsViews } from '~/scenes/PortalViews/Views/AnalyticsViews';
import { EmployeeRouter } from '~/scenes/PortalViews/Views/EmployeeViews';
import { PortalHomepage } from '~/scenes/PortalViews/Views/PortalHomepage';

import { PortalAltMgr } from './Views/PortalAltMgr/component';

export const PortalViewRouter = () => {
  const { path } = useRouteMatch();
  const { isModuleActive } = useAppModules();

  const continuePath = `${path}/continue`;

  return (
    <>
      <HandleCurrentPageCookie ignorePaths={[continuePath]} />
      <Switch>
        <Route exact path={path} render={() => <RedirectToPortalHomepage />} />
        <Route
          path={continuePath}
          render={() => <RedirectToPortalContinue />}
        />

        <Route path={`${path}/home`} component={PortalHomepage} />
        <Route
          path={`${path}/my-workspace`}
          exact={true}
          render={() => {
            if (isModuleActive(Modules.WORKSPACE)) {
              return <MyWorkspace />;
            }

            return <Redirect to={`${path}/home`} />;
          }}
        />
        <Route path={`${path}/my-team`} exact={true} component={MyTeam} />
        <Route
          path={`${path}/all-notifications`}
          exact={true}
          component={LegacyNotificationListPage}
        />
        <Route
          path={`${path}/organizationUnit`}
          exact={true}
          component={PortalAltMgr}
        />

        <Route path={`${path}/employee`} component={EmployeeRouter} />

        <Route path={`${path}/analytics`} component={AnalyticsViews} />

        <Route path={`${path}/admin`} component={AdminViews} />
      </Switch>
    </>
  );
};
